import React from 'react';
import { Sidebar } from './Sidebar';
import { useAuth } from '../../context/AuthContext';
import { useLocation } from 'react-router-dom';
import clsx from 'clsx';
interface AppLayoutProps {
  children: ReactNode;
}
export function AppLayout({
  children
}: AppLayoutProps) {
  const {
    user
  } = useAuth();
  const location = useLocation();
  // Employee chat view is full screen, slightly different layout logic if needed
  // But for now we keep the sidebar for everyone except maybe login (handled in App.tsx)
  const isEmployeeChat = user?.role === 'employee' && location.pathname === '/employee';
  return <div className="min-h-screen bg-background text-primary flex" data-id="element-53">
      {/* Sidebar is fixed */}
      <Sidebar data-id="element-54" />

      {/* Main Content Area */}
      <main className={clsx('flex-1 min-h-screen transition-all duration-300', 'ml-64' // Offset for fixed sidebar
    )} data-id="element-55">
        <div className={clsx('h-full w-full', !isEmployeeChat && 'p-8 max-w-7xl mx-auto' // Standard padding for dashboards
      )} data-id="element-56">
          {children}
        </div>
      </main>
    </div>;
}